import clsx from "clsx";
import type { ComponentProps } from "react";

import { trapTypes } from "@features/ecotrap-card/ecotrap-card";

import { Button } from "@shared/ui/button";
import { ButtonWithIcon } from "@shared/ui/button-with-icon";
import { Icon } from "@shared/ui/icon";
import { Body } from "@shared/ui/typography";

import type { EcotrapType } from "@/_pages/ecotrap/model";

import s from "./ecotrap-content.module.scss";

export type CompProps = ComponentProps<"div"> & {
  data: EcotrapType;
  isTablet?: boolean;
};

export const EcotrapContent = (props: CompProps) => {
  const { data, isTablet } = props;

  // «Файл тропы» — либо загруженный файл, либо ссылка со своим текстом
  const track = data.details?.trackFile?.url
    ? { href: data.details.trackFile.url, text: "скачать трек" }
    : data.details?.trackLink
      ? {
          href: data.details.trackLink,
          text: data.details.trackLinkText || "скачать трек",
        }
      : null;

  return (
    <div
      className={clsx(s.root, { [s.top]: isTablet })}
      data-inner-element="sections"
    >
      <div className={s.benefits}>
        <div className={s.item}>
          <Icon name="trail" className={s.trailIcon} />
          <div>
            <Body
              size="uppercase-small"
              weight="semiBold"
              className={s.subtitle}
            >
              протяженность и время
            </Body>
            <Body size="uppercase-small" weight="semiBold">
              {data.details.distance_time}
            </Body>
          </div>
        </div>
        <div className={s.item}>
          <Icon name="ski" className={s.skiIcon} />
          <div>
            <Body
              size="uppercase-small"
              weight="semiBold"
              className={s.subtitle}
            >
              Перепад высот
            </Body>
            <Body size="uppercase-small" weight="semiBold">
              {data.details.elevation}
            </Body>
          </div>
        </div>
        <div className={s.item}>
          <Icon
            name={trapTypes[data.details.type as keyof typeof trapTypes].icon}
            className={s.typeIcon}
          />
          <div>
            <Body
              size="uppercase-small"
              weight="semiBold"
              className={s.subtitle}
            >
              Тип маршрута
            </Body>
            <Body size="uppercase-small" weight="semiBold">
              {trapTypes[data.details.type as keyof typeof trapTypes].text}
            </Body>
          </div>
        </div>
        <div className={s.item}>
          <Icon name="location" className={s.locationIcon} />
          <div>
            <Body
              size="uppercase-small"
              weight="semiBold"
              className={s.subtitle}
            >
              Старт и финиш
            </Body>
            <Body size="uppercase-small" weight="semiBold">
              {data.details.start} → {data.details.end}
            </Body>
          </div>
        </div>
      </div>
      <div className={s.buttons}>
        {data?.details?.button && (
          <ButtonWithIcon
            variant="secondary-dark"
            href={data?.details?.button?.link}
            className={s.mainBtn}
            iconName={data?.details?.button?.pageIcon?.icon?.name!}
            iconFillColor={data?.details?.button?.pageIcon?.fillColor!}
          >
            {data?.details?.button?.text}
          </ButtonWithIcon>
        )}
        {track && (
          <Button href={track.href} target="_blank" className={s.secondBtn}>
            <Icon name="download" className={s.downloadIcon} />
            <Body size="uppercase-small" weight="semiBold">
              {track.text}
            </Body>
          </Button>
        )}
        {data.details.mapLink && (
          <Button href={data.details.mapLink} className={s.mapButton}>
            <Icon name="map" />
          </Button>
        )}
      </div>
    </div>
  );
};

EcotrapContent.displayName = "EcotrapContent";
